export default __webpack_public_path__ + "static/media/bell-tone.c12689c7.ogg";